import HeaderExterno from '@/modules/criar-conta/HeaderExterno.vue';
import CriarContaNovaEmpresa from '@/modules/criar-conta/CriarContaNovaEmpresa.vue';

export default [
  {
    path: '/nova-conta-empresa',
    name: 'nova-conta-empresa',
    components: {
      header: HeaderExterno,
      default: CriarContaNovaEmpresa,
    },
  },
];
